import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';

import { TranslateModule } from '@ngx-translate/core';

import { TrapFocusDirective } from './directives/trap-focus.directive';

import { ErrorPageComponent } from './components/error-page/error-page.component';
import { EmptyComponent } from './components/empty.component';

@NgModule({
    declarations: [
        TrapFocusDirective, 
        ErrorPageComponent,
        EmptyComponent
    ],
    imports: [CommonModule, RouterModule, FormsModule, TranslateModule, ButtonModule],
    exports: [FormsModule, TranslateModule, TrapFocusDirective, ErrorPageComponent],
})
export class SharedModule {}
